var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    _vm._b({ staticClass: "box-card" }, "el-card", _vm.$attrs, false),
    [
      _vm.header
        ? _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _vm._t("title", function() {
                return [
                  _c("span", { staticClass: "box-card__title" }, [
                    _vm._v(_vm._s(_vm.title))
                  ])
                ]
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "right" },
                [
                  _vm._t("actions", function() {
                    return [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "text" },
                          on: { click: _vm.actionEvent }
                        },
                        [_vm._v(_vm._s(_vm.actionText))]
                      )
                    ]
                  })
                ],
                2
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("search"),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d32d57f8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d32d57f8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Panel.vue
// module id = null
// module chunks = 